import React from "react";
import { Updater } from "use-immer";

import { IgButton, IgCheckbox, IgTypography } from "@intelligems/ig-theme";
import { UserBehaviorFilterType } from "@intelligems/ig-types";
import { FormControlLabel, Grid, Radio, RadioGroup } from "@mui/material";

import { IExperienceDashboardFilters } from "../../store/types/dashboardFilters";

interface UserBehaviorFiltersProps {
  userBehavior: UserBehaviorFilterType;
  setDialogFilters: Updater<IExperienceDashboardFilters>;
}
export const UserBehaviorFilters = ({
  setDialogFilters,
  userBehavior,
}: UserBehaviorFiltersProps) => {
  const onChange = (
    checked: boolean | null,
    filterKey: "viewedCheckout" | "addedToCart"
  ) => {
    setDialogFilters((draft) => {
      draft.userBehavior[filterKey] = checked;
      return draft;
    });
  };
  return (
    <Grid container direction={"column"}>
      <Grid
        item
        container
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Grid item>
          <IgTypography sx={{ fontSize: "14px" }}>Viewed Checkout</IgTypography>
        </Grid>
        <Grid item>
          <Grid item>
            <Grid container>
              {userBehavior.viewedCheckout !== null ? (
                <Grid item>
                  <IgButton
                    variant={"text"}
                    onClick={() => onChange(null, "viewedCheckout")}
                  >
                    Clear
                  </IgButton>
                </Grid>
              ) : null}
              <Grid item>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={
                    userBehavior.viewedCheckout === true
                      ? "yes"
                      : userBehavior.viewedCheckout === false
                        ? "no"
                        : "null"
                  }
                >
                  <FormControlLabel
                    value={"yes"}
                    control={
                      <Radio
                        size={"small"}
                        onClick={() => {
                          onChange(true, "viewedCheckout");
                        }}
                      />
                    }
                    label="Yes"
                  />
                  <FormControlLabel
                    value={"no"}
                    control={
                      <Radio
                        size={"small"}
                        onClick={() => {
                          onChange(false, "viewedCheckout");
                        }}
                      />
                    }
                    label="No"
                  />
                </RadioGroup>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        item
        container
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Grid item>
          <IgTypography sx={{ fontSize: "14px" }}>Added to Cart</IgTypography>
        </Grid>
        <Grid item>
          <Grid container>
            {userBehavior.addedToCart !== null ? (
              <Grid item>
                <IgButton
                  variant={"text"}
                  onClick={() => onChange(null, "addedToCart")}
                >
                  Clear
                </IgButton>
              </Grid>
            ) : null}
            <Grid item>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={
                  userBehavior.addedToCart === true
                    ? "yes"
                    : userBehavior.addedToCart === false
                      ? "no"
                      : "null"
                }
              >
                <FormControlLabel
                  value={"yes"}
                  control={
                    <Radio
                      size={"small"}
                      onClick={() => {
                        onChange(true, "addedToCart");
                      }}
                    />
                  }
                  label="Yes"
                />
                <FormControlLabel
                  value={"no"}
                  control={
                    <Radio
                      size={"small"}
                      onClick={() => {
                        onChange(false, "addedToCart");
                      }}
                    />
                  }
                  label="No"
                />
              </RadioGroup>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
